export default __webpack_public_path__ + "static/media/switchlight.91c368d5.wav";